export default __webpack_public_path__ + "assets/1cde8c437e04e1d6d13d3b5677a331e2.svg";